import { useMemo } from 'react';

import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '../../../lib/utils';
import { useNavbarContext } from '../useNavbarContext';

export interface NavbarTypeToggleButtonProps extends
  Omit<IconButtonProps, 'onClick'>,
  WithDataTestid,
  WithClassNameProp {}

const displayName = 'NavbarTypeToggleButton';
const testid = buildTestid(displayName);

function NavbarTypeToggleButton({
  'data-testid': dataTestId = undefined,
  ...props
}: NavbarTypeToggleButtonProps): React.JSX.Element {
  const { type, toggleType } = useNavbarContext();
  const icon = useMemo(() => {
    switch (type) {
      case 'collapsed': return <ChevronDoubleRightIcon />;
      case 'expanded': return <ChevronDoubleLeftIcon />;
      default: throw new Error('Unknown navbar type');
    }
  }, [type]);

  return (
    <IconButton
      icon={icon}
      kind="secondary"
      onClick={toggleType}
      shape="square"
      variant="dimmed"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

NavbarTypeToggleButton.displayName = displayName;

export { NavbarTypeToggleButton };
